/** 与 Flutter `macaron_widgets` 中常用色值对齐 */
export const MACARON = {
  label: '#161615',
  labelSecondary: '#595856',
  labelTertiary: '#ABAAA6',
  selectionActive: '#8CA62A',
  cardBg: 'rgba(255,255,255,0.74)',
  cardBorder: '#DFDDD7',
  cardShadow: '0 10px 30px -16px rgba(80,26,26,0.12), 0 4px 14px rgba(80,26,26,0.05), inset 0 1px 0 rgba(255,255,255,0.6)',
  dividerDash: '#ABAAA6',
  progressTrack: '#E9E7E2',
  progressFill: '#FF8700',
  ratingStarSelected: '#FF8700',
  ratingStarUnselected: '#DAD8D3',
  ratingText: '#ABAAA6',
  filterTagBg: 'rgba(22, 22, 21, 0.05)',
  filterTagText: '#161615',
  buttonPrimaryStart: '#FFC300',
  buttonPrimaryMid: '#FF5A70',
  buttonPrimaryEnd: '#F63B3B',
  buttonSecondaryBorder: '#DAD8D3',
  imageBorder: '#FFFDF7',
  circularTrack: '#E9E7E2',
  circularPositive: '#8CA62A',
  circularDanger: '#F63B39',
} as const;

export const GAP = {
  cardColumn: 12,
  rowDefault: 12,
  rowInButton: 4,
  textCluster: 4,
} as const;
